import bindAll from 'lodash.bindall';
import classNames from 'classnames';
import omit from 'lodash.omit';
import PropTypes from 'prop-types';
import React from 'react';
import {defineMessages, injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import MediaQuery from 'react-responsive';
// import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
// import tabStyles from 'react-tabs/style/react-tabs.css';
import {VM} from '@hetao/scratch-core';
import {ScratchRender} from '@hetao/scratch-core';

import Blocks from '../../containers/blocks.jsx';
// import CostumeTab from '../../containers/costume-tab.jsx';
import TargetPane from '../../containers/target-pane.jsx';
// import SoundTab from '../../containers/sound-tab.jsx';
import StageWrapper from '../../containers/stage-wrapper.jsx';
import Loader from '../loader/loader.jsx';
import Box from '../box/box.jsx';
// import MenuBar from '../menu-bar/menu-bar.jsx';
import MenuBar from '../../containers/menu-bar.jsx';
import MenuBarAssistant from '../../containers/menu-bar-assistant.jsx';
import CostumeLibrary from '../../containers/costume-library.jsx';
import BackdropLibrary from '../../containers/backdrop-library.jsx';
import FooterInfoBar from '../../containers/footer-info-bar.jsx';

import MaskLayer from '../../containers/mask-layer.jsx';
import Backpack from '../../containers/backpack.jsx';
import PreviewModal from '../../containers/preview-modal.jsx';
import ImportModal from '../../containers/import-modal.jsx';
import WebGlModal from '../../containers/webgl-modal.jsx';
import TipsLibrary from '../../containers/tips-library.jsx';
import Cards from '../../containers/cards.jsx';
// import Alerts from '../../containers/alerts.jsx';
import DragLayer from '../../containers/drag-layer.jsx';
import HomeworkUploadProgress from '../../containers/homework-upload-progress.jsx';
import FinishHomework from '../finish-homework/finish-homework.jsx';
import WhiteList from '../white-list/white-list-pro.jsx';
import HetaoCS from '../hetao-cs/hetao-cs.jsx';
import VideoGuide from '../../containers/video-guide.jsx';
import BackWithoutSubmit from '../back-without-submit/back-without-submit.jsx';

import {isTutor, isAssistantMode, isTeacherMode, isCreateMode, getMode, isNoMenu} from '../../lib/hetao-mode';
import {isMobile} from '../../lib/platform';
import {back} from '../../lib/app/api';


import layout, {STAGE_SIZE_MODES} from '../../lib/layout-constants';
import {resolveStageSize} from '../../lib/screen-utils';

import VirtualBoardCom from '../virtual-keyboard/index.jsx';
import H5IframeModal from '../../containers/h5-iframe-modal.jsx';

import styles from './gui.css';
import addExtensionIcon from './icon--extensions.svg';
// import codeIcon from './icon--code.svg';
// import costumesIcon from './icon--costumes.svg';
// import soundsIcon from './icon--sounds.svg';

import scratchTester from '../../lib/scratch-tester/index';
import {closeWhiteList} from "../../reducers/modals";

const Renderer = ScratchRender;
const messages = defineMessages({
    moreExtension: {
        id: 'gui.gui.moreExtension',
        defaultMessage: '更多模块',
        description: 'Add Extension'
    },
    addExtension: {
        id: 'gui.gui.addExtension',
        description: 'Button to add an extension in the target pane',
        defaultMessage: 'Add Extension'
    }
});

// Cache this value to only retrieve it once the first time.
// Assume that it doesn't change for a session.
let isRendererSupported = null;

class GUIComponent extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'setEditState'
        ]);
        this.state = {
            isEdit: !!this.props.vm.toolboxXML
        };
        scratchTester.init(this.props.vm);
        window.vm = this.props.vm;
    }
    setEditState () {
        // needed to set the opacity to 1, since the default is .9 on show
        this.setState({isEdit: !!this.props.vm.toolboxXML});
    }
    render () {
        const {
            // accountNavOpen,
            // activeTabIndex,
            // alertsVisible,
            basePath,
            backdropLibraryVisible,
            onRequestCloseWhiteListModal,
            backpackOptions,
            // blocksTabVisible,
            cardsVisible,
            children,
            costumeLibraryVisible,
            // costumesTabVisible,
            enableCommunity,
            finishHomeworkWarnVisible,
            whitelistVisible,
            importInfoVisible,
            intl,
            isPlayerOnly,
            isRtl,
            loading,
            maskLayerVisible,
            // renderLogin,
            // onClickAccountNav,
            // onCloseAccountNav,
            // onLogOut,
            // onOpenRegistration,
            // onToggleLoginOpen,
            // onUpdateProjectTitle,
            // onActivateCostumesTab,
            // onActivateSoundsTab,
            // onActivateTab,
            onExtensionButtonClick,
            onRequestCloseBackdropLibrary,
            onRequestCloseCostumeLibrary,
            onRequestCloseVideoGuide,
            onRequestCloseBackWithoutSubmit,
            onSeeCommunity,
            // onShare,
            previewInfoVisible,
            // targetIsStage,
            // soundsTabVisible,
            stageSizeMode,
            tipsLibraryVisible,
            vm,
            uploadProgressVisible,
            videoGuideVisible,
            backWithoutSubmitVisible,
            ...componentProps
        } = omit(this.props, 'dispatch');

        if (children) {
            return <Box {...componentProps}>{children}</Box>;
        }

        // const tabClassNames = {
        //     tabs: styles.tabs,
        //     tab: classNames(tabStyles.reactTabsTab, styles.tab),
        //     tabList: classNames(tabStyles.reactTabsTabList, styles.tabList),
        //     tabPanel: classNames(tabStyles.reactTabsTabPanel, styles.tabPanel),
        //     tabPanelSelected: classNames(tabStyles.reactTabsTabPanelSelected, styles.isSelected),
        //     tabSelected: classNames(tabStyles.reactTabsTabSelected, styles.isSelected)
        // };

        if (isRendererSupported === null) {
            isRendererSupported = Renderer.isSupported();
            if (!isRendererSupported) {
                sa.track('s3_unsupport_webgl');
            }
        }

        return (<MediaQuery minWidth={layout.fullSizeMinWidth}>{isFullSize => {
            const stageSize = resolveStageSize(stageSizeMode, isFullSize);

            return isPlayerOnly ? (
                <StageWrapper
                    isRendererSupported={isRendererSupported}
                    stageSize={stageSize}
                    vm={vm}
                />
            ) : (
                <Box
                    className={styles.pageWrapper}
                    data-type={getMode()}
                    dir={isRtl ? 'rtl' : 'ltr'}
                    {...componentProps}
                >
                    {!loading && maskLayerVisible ? (
                        <MaskLayer />
                    ) : null}
                    {previewInfoVisible ? (
                        <PreviewModal />
                    ) : null}
                    {loading ? (
                        <Loader />
                    ) : null}
                    {importInfoVisible ? (
                        <ImportModal />
                    ) : null}
                    {isRendererSupported ? null : (
                        <WebGlModal isRtl={isRtl} />
                    )}
                    {tipsLibraryVisible ? (
                        <TipsLibrary />
                    ) : null}
                    {cardsVisible ? (
                        <Cards />
                    ) : null}
                    {costumeLibraryVisible ? (
                        <CostumeLibrary
                            vm={vm}
                            onRequestClose={onRequestCloseCostumeLibrary}
                        />
                    ) : null}
                    {backdropLibraryVisible ? (
                        <BackdropLibrary
                            vm={vm}
                            onRequestClose={onRequestCloseBackdropLibrary}
                        />
                    ) : null}
                    {uploadProgressVisible ? (
                        <HomeworkUploadProgress />
                    ) : null}
                    {finishHomeworkWarnVisible ? (
                        <FinishHomework />
                    ) : null}
                    {whitelistVisible ? (
                        <WhiteList
                            media={`${basePath}static/blocks-media/`}
                            setEditState={this.setEditState}
                        />
                    ) : null}
                    {videoGuideVisible ? (<VideoGuide onRequestClose={onRequestCloseVideoGuide} />) : null}
                    {backWithoutSubmitVisible ? (<BackWithoutSubmit
                        onBack={back}
                        onRequestClose={onRequestCloseBackWithoutSubmit}
                    />) : null}
                    {
                        isNoMenu() ? (
                            // <MenuBarAssistant isTutor={isTutor()} />
                            <div />
                        ) : (
                            <MenuBar
                                enableCommunity={enableCommunity}
                                isEdit={this.state.isEdit}
                                vm={vm}
                                onSeeCommunity={onSeeCommunity}
                            />
                        )
                    }
                    <Box className={classNames(styles.bodyWrapper, {
                        [styles.bodyWrapperMenu]: !isNoMenu()
                    })}>
                        <Box className={styles.flexWrapper}>
                            <Box
                                className={classNames(styles.stageAndTargetWrapper, styles[stageSize],
                                    {[styles.mobile]: isMobile()})}
                            >
                                <StageWrapper
                                    isRendererSupported={isRendererSupported}
                                    stageSize={stageSize}
                                    vm={vm}
                                />
                                <Box className={styles.targetWrapper}>
                                    <TargetPane
                                        stageSize={stageSize}
                                        vm={vm}
                                    />
                                </Box>
                            </Box>
                            <Box className={styles.editorWrapper}>
                                <Box className={styles.blocksWrapper}>
                                    {
                                        scratchTester.render(this.props.isScratchTesterVisible)
                                    }
                                    <Blocks
                                        grow={1}
                                        options={{
                                            media: `${basePath}static/blocks-media/`
                                        }}
                                        stageSize={stageSize}
                                        vm={vm}
                                    />
                                </Box>
                                <Box className={styles.extensionButtonContainer}>
                                    <button
                                        className={styles.extensionButton}
                                        title={intl.formatMessage(messages.addExtension)}
                                        onClick={onExtensionButtonClick}
                                    >
                                        {intl.formatMessage(messages.moreExtension)}
                                        <img
                                            className={styles.extensionButtonIcon}
                                            draggable={false}
                                            src={addExtensionIcon}
                                        />
                                    </button>
                                </Box>
                                <Box className={styles.spriteInfoWrapper}>
                                    <FooterInfoBar
                                        stageSize={stageSize}
                                        vm={vm}
                                    />
                                </Box>
                                {backpackOptions.visible ? (
                                    <Backpack host={backpackOptions.host} />
                                ) : null}
                            </Box>
                        </Box>
                    </Box>
                    {isCreateMode() || isTeacherMode() || isAssistantMode() || isTutor() ? null : (
                        <HetaoCS />
                    )}
                    {/* ⬇️ This is VirtualBoard that is just appear in the device of wireless of no keyboard */}
                    { isMobile() && <VirtualBoardCom vm={vm} /> }
                    <DragLayer />
                    <H5IframeModal/>
                </Box>
            );
        }}</MediaQuery>);
    }
}

GUIComponent.propTypes = {
    activeTabIndex: PropTypes.number,
    backdropLibraryVisible: PropTypes.bool,
    backpackOptions: PropTypes.shape({
        host: PropTypes.string,
        visible: PropTypes.bool
    }),
    basePath: PropTypes.string,
    cardsVisible: PropTypes.bool,
    children: PropTypes.node,
    costumeLibraryVisible: PropTypes.bool,
    enableCommunity: PropTypes.bool,
    importInfoVisible: PropTypes.bool,
    isEdit: PropTypes.bool,
    // intl: intlShape.isRequired,
    isPlayerOnly: PropTypes.bool,
    isRtl: PropTypes.bool,
    loading: PropTypes.bool,
    maskLayerVisible: PropTypes.bool,
    onExtensionButtonClick: PropTypes.func,
    onRequestCloseBackdropLibrary: PropTypes.func,
    onRequestCloseCostumeLibrary: PropTypes.func,
    onSeeCommunity: PropTypes.func,
    onTabSelect: PropTypes.func,
    previewInfoVisible: PropTypes.bool,
    stageSizeMode: PropTypes.oneOf(Object.keys(STAGE_SIZE_MODES)),
    tipsLibraryVisible: PropTypes.bool,
    vm: PropTypes.instanceOf(VM).isRequired,
    isScratchTesterVisible: PropTypes.bool
};
GUIComponent.defaultProps = {
    backpackOptions: {
        host: null,
        visible: false
    },
    basePath: window._cdnEndpoint ? window._cdnEndpoint + '/' : 'https://match-ide.pipacoding.com/web/scratch-gui/',
    stageSizeMode: STAGE_SIZE_MODES.small,
    isScratchTesterVisible: false
};

const mapStateToProps = state => ({
    // This is the button's mode, as opposed to the actual current state
    stageSizeMode: state.scratchGui.stageSize.stageSize
});

const mapDispatchToProps = dispatch => ({
    onRequestCloseWhiteListModal: () => dispatch(closeWhiteList())
});

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(GUIComponent));
